import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { AccountType } from "../../../../models/AccountData";
import DataSvc from "../../../../services/dataSvc";
import { OptionalRender } from "../../../Common/OptionalRender";

import "./styles.scss";

interface IAIGenerateButtonProps {
  url: string;
  customizedPrompt?: string;
  onGenerate: (text: string) => void;
}

export const AIGenerateButton = (props: IAIGenerateButtonProps) => {
  const { url, onGenerate, customizedPrompt = "" } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`hookForm.textarea.aiGenerateButton.${key}`);

  const handleGenerate = useCallback(async () => {
    try {
      const response = await DataSvc.generateAiText(url, {
        customized_prompt: customizedPrompt,
      });
      // Simple fail-safe in case a non-string response is returned.
      if (typeof response === "string") {
        // Gemini sometimes returns a string with a newline character at the end. Trim it off for UX.
        onGenerate(response.trim());
      }
    } catch {
      // Do nothing, axios will handle the error
    }
  }, [url, onGenerate, customizedPrompt]);

  return (
    <OptionalRender
      mustBeOneOfRoles={[AccountType.ADMIN]}
      mustBeImpersonating={true}
    >
      <button
        className="hook-form-ai-generate-button btn btn-border"
        type="button"
        onClick={handleGenerate}
      >
        {t("generate")}
      </button>
    </OptionalRender>
  );
};
